import {addMapping, getSelectorParts, removeMappings} from '../property-selectors';

export default function updateSelectedPropertyMappings(
	propertyValue,
	consumerPropName,
	consumerId,
	shouldRemove = true
) {
	const [providerId, providerPropName, providerPropPath] = getSelectorParts(propertyValue);

	if (shouldRemove) removeMappings(consumerId, consumerPropName);

	if (providerId && providerPropName)
		addMapping({providerId, providerPropName, providerPropPath}, {consumerId, consumerPropName});
}
